import { createContext, useContext, useLayoutEffect, useRef } from "react";

export type Draft = { dirty: boolean; pending: boolean };
export type Guard = { drafts: Map<symbol, Draft>; allow: () => boolean };
export const DraftContext = createContext<Guard | null>(null);

/** Detail owners report draft state without knowing their surrounding route. */
export function useAssignmentDraft(dirty: boolean, pending: boolean) {
  const guard = useContext(DraftContext);
  const id = useRef(Symbol("assignment-draft"));
  useLayoutEffect(() => {
    const key = id.current;
    guard?.drafts.set(key, { dirty, pending });
    return () => { guard?.drafts.delete(key); };
  }, [guard, dirty, pending]);
  return guard?.allow ?? (() => !pending);
}
